import { Environment } from '../../env/Environment';
import Alert from '../ui/Alert';
import { Trans } from '@rpi/i18n';
import React from 'react';

export const LargeOrderServicesAlert = () => {
  return (
    <Alert variant="success" data-testid="large-orders">
      <Trans
        i18nKey={'route.cart.large_orders'}
        components={{
          'los-link': (
            <a
              aria-label="LOS Link"
              href={Environment.LINK.BLURB_LOS}
              target="_blank"
              rel="noopener noreferrer"
            />
          ),
        }}
      />
    </Alert>
  );
};
